export enum DesktopProcessStatus {
    completed = 'completed',
    downloading = 'downloading',
    running = 'running',
    starting = 'starting',
    uploading = 'uploading',
}
